import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {Router} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';


@Component({
  selector: 'app-upload-rrms-service-live-data',
  templateUrl: './upload-rrms-service-live-data.component.html',
  styleUrls: ['./upload-rrms-service-live-data.component.scss']
})
export class UploadRrmsServiceLiveDataComponent implements OnInit {

  fileInputPlaceHolder:string;
  fileToUpload: File = null;
  folderName:string;
  uploadRrmsServiceLiveFormGroup: FormGroup;
  priorityDropdownValue: any;
  homeTadigArray: any = [];
  loadPage: boolean;
   submitted: boolean = false;
   spinner5="sp5";
   showErrormessage:boolean=false;
   showSuccessmessage:boolean=false;
   sucssmsg:any;
   errmsg:any;

  canCreateSOR: boolean;

  constructor(private dialogRef: MatDialogRef<UploadRrmsServiceLiveDataComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private backendApiService:BackendApiService,private Endpointservice:EndpointsService,
  private formBuilder: FormBuilder,
   private spinnerService :Ng4LoadingSpinnerService,
  private router:Router) { }

  ngOnInit(): void {
     this.spinnerService.show();
    this.fileInputPlaceHolder = 'Choose File';
    this.createUplodrrmsServiceForm()
   
  }
  // this.createUploadSorForm();
  //   // this.spinnerService.hide();
  //   this.loadPage = true;
  // }
  createUplodrrmsServiceForm() {
    this.uploadRrmsServiceLiveFormGroup = this.formBuilder.group({
      
     
      attachment:['',Validators.required],
    });
  }
  get f() {
    return this.uploadRrmsServiceLiveFormGroup.controls;
  }
  handleFileInput(event: any) {
    const files = event.target.files;
    console.log('files',files.type)
    this.folderName=files[0].name.substring(0,files[0].name.indexOf("."));
    const file =files[0]
    console.log("mmmmm",file)
    console.log('folderName',this.folderName)
    const fileExtension=files[0].name.split('.').pop().toLowerCase();
    console.log("fffffff",fileExtension)
    console.log("fileExtension",fileExtension.type)
    if (files.item(0) == null) {
      return;

    }

    if(fileExtension === 'xlsx'  ){
      this.fileToUpload = files.item(0);
      this.fileInputPlaceHolder = files.item(0).name;
      console.log('fileessUpload',this.fileToUpload);
    }else{
      alert('Invalid type. Accept only .xlsx file');
      return;
    }
  }

  clearFileEvent(event: any) {
    event.target.value = '';

  }

  onUpload(){
    console.log('fileessUploaddddddd',this.fileToUpload);
    this.submitted = true;

    if (this.uploadRrmsServiceLiveFormGroup.invalid ) {
      return;
    }
    const formData = new FormData();

    formData.append('file', this.fileToUpload);
    console.log("formdata",formData)
     this.spinnerService.show();
    this.backendApiService.postApi(this.Endpointservice.URL_UPLOAD_RRMS_SERVICE_LIVE_DATA,formData)
    .then(response => {
      console.log("res",response)
     if(response.status ==='true'){
   setTimeout(() => {
          this.spinnerService.hide();
        }, 2000);
        const apiUrl = this.Endpointservice.URL_GET_UPLOAD_RRMS_SERVICE_LIVE_DATA + '?fileName=' + this.folderName
        this.backendApiService.callToApi(apiUrl).subscribe(response =>{
          console.log("response",response);
          if(response.status ==='true'){
            alert("File Upload Sucessfully")
          }else{            
           return;
          }
        })
        // alert("File Upload Sucessfully")
        console.log("dddddddddddddddddddddddddddd")
     }
    })
  }
  onClose() {
    this.dialogRef.close('close');
  }

}
